import React, { useEffect, useState, useRef, useCallback, useContext } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import './bulkSubmitModal.css';
import CloseIcon from '@mui/icons-material/Close';
import Warning from '@mui/icons-material/Warning';
import Settings from '../../../components/Icons/setting';
import ArrowSubmit from '../../../components/Icons/arrowsubmit';
import { DateTime } from 'luxon';
import Approved from '../../../components/Icons/approved';
import ArrowBack from '@mui/icons-material/ArrowBack';
import Visibility from '@mui/icons-material/Visibility';
import LockOutline from '@mui/icons-material/LockOutline';
import ReviewStages from './ReviewStages';
import getAllActiveRequisitions from '../../../apis/getAllActiveRequisitions/getAllActiveRequisitions';
import { NotificationManager } from 'react-notifications'
import getRecruitersByRequisitionId from '../../../apis/getRecruitersByRequisitionId/getRecruitersByRequisitionId';
import getAllCandidateRequisitionStatus from '../../../apis/getAllCandidateRequisitionStatus/getAllCandidateRequisitionStatus';
import getCandidateRequisitionInfo from '../../../apis/getCandidateRequisitionInfo/getCandidateRequisitionInfo';
import getCandidateFieldOptions from '../../../apis/getCandidateFieldOptions/getCandidateFieldOptions';
import getCandidateSubmissionField from '../../../apis/submission/getCandidateSubmissionField';
import { renderStageRequiredField } from "./RenderRequiredField"
import configJSON from "../../../Config.json";
import Pending from '../../../components/Icons/pending';
import Rejected from '../../../components/Icons/rejected';
import Download from '../../../components/Icons/download';
import mammoth from 'mammoth';
import resendCandidateRequistionAttachments from '../../../apis/resendCandidateRequistionAttachments';
import SubmissionComp from '../../../components/AcitivityModal/SubmissionComp';
import candidateBulkAction from '../../../apis/candidateBulkAction/candidateBulkAction';
import BulkSubmitModalSkeleton from './BulkSubmitModalSkeleton';
import { UserTypeContext } from '../../../AppRoute';
import RecruiterCandidateHistory from "../../../components/RecruiterCandidateHistory/RecruiterCandidateHistory";
import UploadResumeModal from '../../../components/UploadResumeModal/UploadResumeModal';
import Button from '@mui/material/Button';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';
import profileResponse from '../../../apis/profile/profileById';
import candidateSubmissionConfig from "../../../utilities/candidateSubmissionConfig"


const BulkSubmitModal = (props) => {
    const { openBukSubmitModal, setOpenBukSubmitModal, candidateList, setCandidateList, userType, userId, recruitmentpartnerId, requisitionId, sourcePage, moveCandidate } = props;
    const { userRecords } = useContext(UserTypeContext);
    const [selectedTab, setSelectedTab] = useState(0);
    const [selectedCandidate, setSelectedCandidate] = useState({
        candidateData: null,
        submitData: {},
        submittedByOther: false,
    });
    const [editCandidateStageToggle, setEditCandidateStageToggle] = useState(false);
    const [candidateRequisitionStatus, setCandidateRequisitionStatus] = useState([]);
    const [candidateFields, setCandidateFields] = useState({});
    const [candidateSubmissionField, setCandidateSubmissionField] = useState([]);
    const [submitDataFromModal, setSubmitDataFromModal] = useState([]);
    const [sharedAdditionalSpoc, setSharedAdditionalSpoc] = useState([]);
    const [isAdditionalSpocRequiredGlobal, setIsAdditionalSpocRequiredGlobal] = useState(false); // from SubmissionComp
    const [hasActiveSubmissionConfig, setHasActiveSubmissionConfig] = useState(false); // track active config presence
    const [formattedSubmissionData, setFormattedSubmissionData] = useState({}); // store formatted submission data with proper phone format
    const [contentLoader, setContentLoader] = useState(false);
    const [rtrDialogOpen, setRtrDialogOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [enableSkeleton, setEnableSkeleton] = useState(false);
    const [requisitionIdInput, setRequisitionIdInput] = useState('');
    const [isFetchingRequisition, setIsFetchingRequisition] = useState(false);
    const [lastFetchedRequisitionInput, setLastFetchedRequisitionInput] = useState('');

    const [expandedAccordions, setExpandedAccordions] = useState({
        requiredFields: true,
        rightToRepresent: false,
        candidateSubmission: false,
        formData: false
    });
    const [isAPiRunning, setIsApiRunning] = useState({
        requisitionListFetching: false,
        recruiterListFetching: false,
        contentBlurred: true,
        candidatesDataFetch: false,
        rtrFetching: false,
        rtrResending: false,
        reqruiredRequisitionInfoFetch: false,
    });
    const [selectedRequisitionInfo, setSelectedRequisitionInfo] = useState({
        requisitionDetailData: {},
        recruiterRequisitionData: {},
        requisitionList: [],
        recruiterRquisitionList: [],
    });
    const [rtrData, setRtrData] = useState({
        rtrLinkdownload: '',
        rtrText: ''
    })

    const isFetchingRequisitionList = useRef(false);
    const isFetchingRecruiterList = useRef(false);
    const [isRequisitionIdLocked, setIsRequisitionIdLocked] = useState(!!requisitionId);
    const [isRecruiterIdLocked, setIsRecruiterIdLocked] = useState(false);
    const [candidateFieldPrevValues, setCandidateFieldPrevValues] = useState({});
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
    const [mandatoryFieldsValidation, setMandatoryFieldsValidation] = useState({});
    // Resume upload state variables
    const [showResumeModal, setShowResumeModal] = useState(false);
    const [isResumeUploadLoader, setIsResumeUploadLoader] = useState(false);
    const [resumeDataForCandidate, setResumeDataForCandidate] = useState({});
    // Removed unused historyData state
    const hasFetchedCandidatesRef = useRef(false);
    const hasFetchedRequisitionRef = useRef(false);
    const [historyModal, setHistoryModal] = useState(false)
    const [currencyOptions, setCurrencyOptions] = useState([]);

    const candidates = candidateList;


    const removeCandidateByEmail = (email) => {
        const newList = candidateList.filter(c => c.emailID !== email);
        setCandidateList(newList);

        const newSubmitData = submitDataFromModal.filter(item => item.email !== email);
        setSubmitDataFromModal(newSubmitData);

        if (selectedCandidate.candidateData?.emailID === email) {
            setSelectedCandidate({ candidateData: null, submitData: {}, submittedByOther: false });
        }
        if (selectedTab >= newList.length) {
            setSelectedTab(Math.max(0, newList.length - 1));
        }
    };

    const toggleAccordion = (accordion) => {
        setExpandedAccordions(prev => ({
            ...prev,
            [accordion]: !prev[accordion]
        }));
    };

    const updateFormValue = (field, value) => {
        let allcandidateSubmitData = [...submitDataFromModal];
        let index = allcandidateSubmitData.findIndex(item => item.email === selectedCandidate?.candidateData?.emailID);
        if (index !== -1) {
            if (field === 'gender' || field === 'currentStatus') {
                setCandidateFieldPrevValues(prev => ({
                    ...prev,
                    [allcandidateSubmitData[index].email]: {
                        ...prev[allcandidateSubmitData[index].email],
                        [field]: allcandidateSubmitData[index].candidateRequisitionInfoFields[field]
                    }
                }));
            }
            allcandidateSubmitData[index].candidateRequisitionInfoFields = {
                ...allcandidateSubmitData[index].candidateRequisitionInfoFields,
                [field]: value,
                isValueChanged: true
            };
            const originalCandidate = candidateList.find(c => c.emailID === allcandidateSubmitData[index].email);
            const currentGender = allcandidateSubmitData[index].candidateRequisitionInfoFields.gender;
            const currentStatus = allcandidateSubmitData[index].candidateRequisitionInfoFields.currentStatus;
            const originalGender = originalCandidate?.gender || '';
            const originalStatus = originalCandidate?.currentStatus || '';
            allcandidateSubmitData[index].isFieldChange = (currentGender !== originalGender) || (currentStatus !== originalStatus);

            setSubmitDataFromModal(allcandidateSubmitData);
            setSelectedCandidate({
                ...selectedCandidate,
                submitData: allcandidateSubmitData[index],
            });
        }
    }

    const goToHistory = () => {
        setHistoryModal(true);
    }

    const handleRequisitionChange = (e, value) => {
        setSelectedRequisitionInfo({
            ...selectedRequisitionInfo,
            requisitionDetailData: value || {},
            recruiterRequisitionData: {},
            recruiterRquisitionList: []
        });
        setIsApiRunning({
            ...isAPiRunning,
            contentBlurred: true
        })
        if (value && userType === 'Recruiter' && sourcePage !== 'Activity') {
            setIsRecruiterIdLocked(true);
            fetchRecruiterListData(value);
        }
    };

    const fetchRequisitionData = async (reqRefId) => {
        if (isFetchingRequisition) return;
        const requestedReqRefId = (reqRefId || requisitionIdInput || '').trim();
        setIsFetchingRequisition(true);
        if (requisitionId) {
            setIsApiRunning(prev => ({ ...prev, reqruiredRequisitionInfoFetch: true }));
        }
        else {
            setIsApiRunning(prev => ({ ...prev, requisitionListFetching: true, }));
        }
        try {
            let payload = {
                userType: userType,
                userId: userId,
                recruitmentpartnerId: recruitmentpartnerId,
                reqRefId: reqRefId
            }
            if (requisitionId) {
                payload.requisitionId = requisitionId;
                setIsRequisitionIdLocked(true);
            }
            const response = await getAllActiveRequisitions(payload);
            if (response.status === 200) {
                if (response.data.data.length === 0) {
                    NotificationManager.error('Unable to submit: At least one team or one recruiter must be assigned to the requisition', 'Error', 4500);
                    handleCloseModal();
                }
                let dataTobeSet = {
                    requisitionList: response.data.data || [],
                }
                if (response.data.data.length > 0) {
                    setRequisitionIdInput(response.data.data[0].reqreferenceId || '');
                    setLastFetchedRequisitionInput((requestedReqRefId || response.data.data[0].reqreferenceId || '').trim());
                }
                if (requisitionId || reqRefId) {
                    dataTobeSet.requisitionDetailData = response.data.data[0];
                    if (userType === 'Recruiter' && sourcePage !== 'Activity') {
                        setIsRecruiterIdLocked(true);
                        fetchRecruiterListData(dataTobeSet.requisitionDetailData);
                    }
                    if (sourcePage === 'Activity') {
                        fetchRequiredCandidatesData(dataTobeSet.requisitionDetailData, {});
                    }
                }
                setSelectedRequisitionInfo(prev => ({
                    ...prev,
                    ...dataTobeSet
                }));
                setEnableSkeleton(false);
            } else {
                NotificationManager.error(response.errMessage || 'Failed to fetch requisitions data', 'Error', 10000);
            }
        } catch (error) {
            NotificationManager.error(error?.response?.data?.errMessage || 'Failed to fetch requisitions data', 'Error', 10000);
            console.error('Error fetching requisitions:', error);
        } finally {
            setIsApiRunning(prev => ({ ...prev, requisitionListFetching: false, reqruiredRequisitionInfoFetch: false }));
            setIsFetchingRequisition(false);
        }
    }

    const handleCloseModal = () => {
        setOpenBukSubmitModal(false);
        setSelectedTab(0);
        setSelectedCandidate({
            candidateData: null,
            submitData: {},
            submittedByOther: false,
        });
        setExpandedAccordions({
            requiredFields: true,
            rightToRepresent: false,
            candidateSubmission: false,
            formData: false
        });
        setSelectedRequisitionInfo({
            requisitionDetailData: {},
            recruiterRequisitionData: {},
            recruiterRquisitionList: [],
            requisitionList: []
        });
        // Reset resume-related states
        setShowResumeModal(false);
        setIsResumeUploadLoader(false);
        setResumeDataForCandidate({});
        setFormattedSubmissionData({});
        setLastFetchedRequisitionInput('');
        setIsApiRunning({
            requisitionListFetching: false,
            recruiterListFetching: false,
            contentBlurred: true,

        });

        isFetchingRequisitionList.current = false;
        isFetchingRecruiterList.current = false;
        hasFetchedCandidatesRef.current = false;
    }

    const fetchRecruiterListData = async (selectedRequisition) => {
        if (isFetchingRecruiterList.current) return;
        isFetchingRecruiterList.current = true;
        setIsApiRunning(prev => ({ ...prev, recruiterListFetching: true }));
        try {


            let payload = {
                requisitionId: selectedRequisition?.requisitionId,
                recruitmentpartnerId: recruitmentpartnerId || '',
                userType: userType,
                userId: userId,
            }
            let response = await getRecruitersByRequisitionId(payload);
            if (response.status === 200) {
                let dataTobeSet = {
                    recruiterRquisitionList: response.data.data || [],
                }
                if ((requisitionId && userType === 'Recruiter') || userType === 'Recruiter') {
                    dataTobeSet.recruiterRequisitionData = response.data.data[0] || {};
                    fetchRequiredCandidatesData(selectedRequisition, dataTobeSet.recruiterRequisitionData);
                }
                setSelectedRequisitionInfo(prev => ({
                    ...prev,
                    ...dataTobeSet
                }));
            }
            else {
                NotificationManager.error('Failed to fetch recruiters data', 'Error', 10000);
            }
        }
        catch (error) {
            NotificationManager.error('Failed to fetch recruiters data', 'Error', 10000);
            console.error('Error fetching recruiters:', error);
        }
        finally {
            setIsApiRunning(prev => ({ ...prev, recruiterListFetching: false }));
            isFetchingRecruiterList.current = false;
        }
    }

    const handleRecruiterChange = async (e, value) => {
        setSelectedRequisitionInfo({
            ...selectedRequisitionInfo,
            recruiterRequisitionData: value || {}
        })
        setIsApiRunning(prev => ({ ...prev, contentBlurred: true }));
        fetchRequiredCandidatesData(selectedRequisitionInfo.requisitionDetailData, value)
    }

    const handleFetchRtr = async () => {
        try {
            setIsApiRunning(prev => ({ ...prev, rtrFetching: true }));
            if (selectedCandidate?.submitData?.rtrDownloadlink && selectedCandidate?.submitData?.rtrText) {
                setRtrDialogOpen(true);
                setRtrData({
                    rtrLinkdownload: selectedCandidate?.submitData?.rtrDownloadlink,
                    rtrText: selectedCandidate?.submitData?.rtrText
                })
            }
            else {
                let link = selectedCandidate?.submitData?.candidateRequisitionAttachments?.rtr[0]?.link;
                let splittedLink = link ? link.split('.') : [];
                if (splittedLink[splittedLink.length - 1] === 'docx') {
                    setRtrDialogOpen(true);
                    if (link) {
                        const response = await fetch(link);
                        const arrayBuffer = await response.arrayBuffer();
                        const result = await mammoth.convertToHtml({ arrayBuffer });
                        let extractedText = result.value;
                        setRtrData({
                            rtrLinkdownload: link,
                            rtrText: extractedText
                        });
                        let updatedSubmitData = [...submitDataFromModal];
                        let index = updatedSubmitData.findIndex(item => item.email === selectedCandidate?.candidateData?.emailID);
                        if (index !== -1) {
                            updatedSubmitData[index].rtrDownloadlink = link;
                            updatedSubmitData[index].rtrText = extractedText;
                            setSubmitDataFromModal(updatedSubmitData);
                            setSelectedCandidate({
                                ...selectedCandidate,
                                submitData: updatedSubmitData[index]
                            });
                        }
                    }
                }
                else {
                    window.open(link, "_blank");
                }
            }
            setIsApiRunning(prev => ({ ...prev, rtrFetching: false }));
        } catch (error) {
            console.error("Error processing the file:", error);
        }
    };

    const getResumeData = async (candidate) => {
        try {
            let raw = [];
            const arr = [];
            raw = candidate?.candidateRequisition?.resumeLink ?? candidate?.resumeDetails?.resumeUrl ?? [];
            if (raw.length === 0 && candidate?.resumeDetails?.powerResumeId) {
                let response = await profileResponse(candidate?.resumeDetails?.powerResumeId);
                let resumeDetails = response.data.data || {};
                if (resumeDetails[0]?.resumeUrl) {
                    arr.push({
                        link: resumeDetails[0].resumeUrl,
                        uploadedDate: resumeDetails[0].updatedAt || DateTime.now().toISO()
                    });
                }

            } else {
                if (Array.isArray(raw)) {
                    raw.forEach(el => {
                        if (!el) return;
                        if (typeof el === 'object' && typeof el.link === 'string' && el.link.trim()) {
                            arr.push({ link: el.link.trim(), uploadedDate: el.uploadedDate || DateTime.now().toISO() });
                        } else if (typeof el === 'string' && el.trim()) {
                            arr.push({ link: el.trim(), uploadedDate: DateTime.now().toISO() });
                        }
                    });
                } else if (typeof raw === 'string' && raw.trim()) {
                    arr.push({ link: raw.trim(), uploadedDate: candidate?.resumeDetails?.lastUploadDate || DateTime.now().toISO() });
                }
            }
            return arr;
        } catch (error) {
            NotificationManager.error('Failed to fetch resume data', 'Error', 10000);
            console.error('Error fetching resume data:', error);
        } finally {
            setIsResumeUploadLoader(false);
        }
    }


    const handleSetSubmitDataFromModal = async (selectedRequisition, selctedCandidatesData, canReqStatusResponse, recruiterRequisitionData) => {
        let dataArray = [];
        let submitStatus = canReqStatusResponse.find((item) => item.candidateStatusCode === configJSON.candidateRequisitionStatusCode.SUBMITTED) || {}
        setSubmitDataFromModal([]);
        setSelectedCandidate({
            ...selectedCandidate,
            submittedByOther: false
        })
        let submittedByOther = []

        for (const candidate of selctedCandidatesData) {
            // if(candidate?.email===selectedCandidate.candidateData.emailID){
            //     setHistoryData(elem=>({...elem,canReqId:candidate?.candidateRequisition?._id}))
            // }
            let candidateData = {
                id: candidate?.candidateRequisition?._id,
                candidateDetailId: candidate?.resumeDetails?._id || '',
                name: candidate?.resumeDetails?.name || '',
                email: candidate?.resumeDetails?.emailID || '',
                phone: candidate?.resumeDetails?.phoneNumber || '',
                displayDate: candidate?.candidateRequisition?.displayDate ? DateTime.fromISO(candidate?.candidateRequisition?.displayDate).toJSDate() : DateTime.now().toJSDate(),
                submissionType: candidate?.candidateRequisition?.submissionType || '',
                eventDate: candidate?.candidateRequisition?.eventDate ? DateTime.fromISO(candidate?.candidateRequisition?.eventDate).toJSDate() : null,
                salary: candidate?.candidateRequisition?.salary || '',
                hourlyPayRate: candidate?.candidateRequisition?.hourlyPayRate || '',
                hourlyMargin: candidate?.candidateRequisition?.hourlyMargin || '',
                endDate: candidate?.candidateRequisition?.endDate ? DateTime.fromISO(candidate?.candidateRequisition?.endDate).toJSDate() : null,
                eventStatus: candidate?.candidateRequisition?.eventStatus || [],
                // Normalize resumeLink to an array of { link, uploadedDate } objects.
                resumeLink: await getResumeData(candidate) || [],
                isStageChanged: false,
                candidateRequisitionInfoFields: {
                    currentStatus: candidate?.candidateRequisition?.candidateRequisitionInfo?.currentStatus || "",
                    gender: candidate?.candidateRequisition?.candidateRequisitionInfo?.gender || "",
                    teamLeaderInfo: candidate?.leadersDeatils?.teamLeaderData || {},
                    recruitmentLeaderInfo: candidate?.leadersDeatils?.recruitmentLeaderData || {},
                    isValueChanged: false
                },
                candidateRequisitionAttachments: candidate?.candidateRequisition?.candidateRequisitionAttachments || null,
                candidateReqInfo: candidate?.candidateRequisition?.candidateRequisitionInfo || {},
                candidateSubmissionData: candidate?.candidateRequisition?.candidateSubmissionFieldMap || {},
                candidateCompleteResume: candidate?.resumeDetails,
                requisitionDetailId: candidate?.candidateRequisition?.requisitionDetailId || selectedRequisition?._id || '',
                requisitionId: candidate?.candidateRequisition?.requisitionId || selectedRequisition.requisitionId || '',
                requisitionLeaderId: candidate?.candidateRequisition?.requisitionLeaderId || recruiterRequisitionData?.requisitionLeaderId || '',
                requisitionRecruiterId: candidate?.candidateRequisition?.requisitionRecruiterId || recruiterRequisitionData?._id || '',
                requisitionTeamLeaderId: candidate?.candidateRequisition?.requisitionTeamLeaderId || recruiterRequisitionData?.requisitionTeamLeaderId || '',
                teamId: candidate?.candidateRequisition?.recruiterRequisitionDetails?.team?.teamId || recruiterRequisitionData?.team?.teamId || '',
                recruiterId: candidate?.candidateRequisition?.recruiterRequisitionDetails?.recruiterId || recruiterRequisitionData?.recruiterId || '',
                reqreferenceId: selectedRequisition?.reqreferenceId,
                teamLeaderId: candidate?.candidateRequisition?.recruiterRequisitionDetails?.team?.teamLeaderId || recruiterRequisitionData?.team?.teamLeaderId || '',
                recruitmentLeaderId: selectedRequisition?.assignedTo,
                isStageValueUpdated: false,
                candidateRequisitionId: candidate?.candidateRequisition?._id || '',
                recruiterData: candidate?.recruiterData || {},
                isFieldChange: false,
                isStatusChange: false,
            }

            let candidateSubmissionData = candidate?.candidateRequisition?.candidateSubmissionFieldMap || {}
            if (Object.keys(candidateSubmissionData).length > 0 && candidateSubmissionData?.details && Object.keys(candidateSubmissionData?.details).length > 0) {
                let submissionDetailData = candidateSubmissionData.details
                submissionDetailData.forEach(item => {
                    if (item.subCode === candidateSubmissionConfig.totalExperience || item.subCode === candidateSubmissionConfig.relevantExperience) {
                        let value = item.value
                        let years = Math.floor(value);
                        let months = Math.round((value - years) * 12);
                        item.value = { years, months }
                    }
                })
            }
            candidateData.candidateSubmissionData = candidateSubmissionData;

            if (Object.keys(candidate.candidateRequisition).length > 0) {
                candidateData.candidateReqExist = true;
                candidateData.status = canReqStatusResponse.find((item) => item.candidateStatusCode === candidate?.candidateRequisition?.status?.candidateStatusCode) || {};
                candidateData.currentStatus = candidateData.status
                let currentEventStatusData = candidate.candidateRequisition.eventStatus.find((item) => item.candidateStatusCode === candidate.candidateRequisition.status?.candidateStatusCode && item.isCurrentlyUsed === true);
                candidateData.currentActivityStatus = {
                    candidateStatusCode: currentEventStatusData.candidateStatusCode,
                    candidateStatusCodeId: currentEventStatusData.candidateStatusCodeId,
                    activityLogs: currentEventStatusData.activityLogs[0] || {},
                }
                candidateData.newActivityStatus = {}
                let requiredFields = candidateData.currentStatus.fields || [];
                if (selectedRequisition.placementType === "Contract") {
                    requiredFields = requiredFields.filter(field => field.altName !== 'salary');
                }
                else {
                    requiredFields = requiredFields.filter(field => field.altName !== 'hourlyPayRate' && field.altName !== 'hourlyMargin' && field.altName !== 'endDate');
                }
                candidateData.currentStatus.fields = requiredFields;
            }
            else {
                candidateData.candidateReqExist = false;
                candidateData.status = submitStatus
                candidateData.currentStatus = submitStatus;
                candidateData.currentActivityStatus = {
                    candidateStatusCode: submitStatus.candidateStatusCode,
                    candidateStatusCodeId: submitStatus._id,
                };
                let requiredFields = submitStatus.fields || [];
                if (selectedRequisition.placementType === "Contract") {
                    requiredFields = requiredFields.filter(field => field.altName !== 'salary');
                }
                else {
                    requiredFields = requiredFields.filter(field => field.altName !== 'hourlyPayRate' && field.altName !== 'hourlyMargin' && field.altName !== 'endDate');
                }
                candidateData.currentStatus.fields = requiredFields
                let activityLogsData = {}
                requiredFields.forEach(item => {
                    if (item.altName === "displayDate") {
                        activityLogsData[item.altName] = DateTime.now().toISO();
                    }
                    else {
                        activityLogsData[item.altName] = '';
                    }
                })
                candidateData.currentActivityStatus.activityLogs = activityLogsData;
                candidateData.newActivityStatus = candidateData.currentActivityStatus;
            }
            if ((candidateData.candidateReqExist === true) && (candidateData.recruiterId !== recruiterRequisitionData?.recruiterId) && sourcePage !== 'Activity') {
                candidateData.submittedByOther = true;
                submittedByOther.push(candidateData.name);
            }
            dataArray.push(candidateData);
        }
        let currentCandidateData = dataArray.find((item) => item.email === selectedCandidate?.candidateData?.emailID) || {};
        setSelectedCandidate({
            ...selectedCandidate,
            submitData: currentCandidateData,
            submittedByOther: currentCandidateData?.submittedByOther || false
        })
        setSubmitDataFromModal(dataArray);
        if (submittedByOther.length > 0) {
            NotificationManager.error(`Candidates ${submittedByOther.join(', ')} have already been submitted to this requisition by other recruiters`, 'Warning', 10000);
        }
    };

    const fetchRequiredCandidatesData = async (selectedRequisition, recruiterRequisitionData) => {

        try {
            let canReqStatusResponse;
            if (candidateRequisitionStatus.length === 0) {
                canReqStatusResponse = await getAllCandidateRequisitionStatus();
                if (canReqStatusResponse.status === 200) {
                    setCandidateRequisitionStatus(canReqStatusResponse.data.data || []);
                }
            }
            let candidateEmails = candidateList.map(candidate => candidate.emailID)
            let candidateDataResponse = await getCandidateRequisitionInfo({
                requisitionDetailId: selectedRequisition?._id || '',
                email: candidateEmails,
                recruitmentpartnerId: recruitmentpartnerId,
                recruiterId: recruiterRequisitionData?.recruiterId || ''
            })
            if (candidateDataResponse.status === 200) {
                let selectedCandidatesData = candidateDataResponse.data.data || [];
                let candidateStatusList = candidateRequisitionStatus.length > 0 ? candidateRequisitionStatus : canReqStatusResponse?.data?.data || [];
                handleSetSubmitDataFromModal(selectedRequisition, selectedCandidatesData, candidateStatusList, recruiterRequisitionData);
            }
            if (Object.keys(candidateFields).length === 0) {
                let candidateFieldsData = await getCandidateFieldOptions()
                let genderOptions = candidateFieldsData.find(item => item.name === "gender").optionList || [];
                let currentStatusOptions = candidateFieldsData.find(item => item.name === "currentStatus")?.optionList || [];
                setCandidateFields({
                    currentStatus: currentStatusOptions,
                    gender: genderOptions,
                });
            }
            if (candidateSubmissionField.length === 0) {
                let submissionFieldResponse = await getCandidateSubmissionField()
                setCandidateSubmissionField(submissionFieldResponse.data.data || []);
            }
            setIsApiRunning(prev => ({ ...prev, candidatesDataFetch: false, contentBlurred: false }));
        } catch (error) {
            console.error('Error fetching required candidates data:', error);
            NotificationManager.error('Failed to fetch candidates data', 'Error', 10000);
        }
    };

    const getFilteredRequisitionStatus = () => {

        let statusDropdown = []
        let statusOptions = candidateRequisitionStatus || [];

        let currendCandidateData = selectedCandidate?.submitData || {};

        if (statusDropdown.length > 0 || currendCandidateData?.status) {
            let currentStatusCode = currendCandidateData?.currentStatus?.candidateStatusCode

            let statusOptions_selected = statusOptions.find((item) => item.candidateStatusCode === currentStatusCode)
            let statusOptionToBeShown = statusOptions_selected?.statusOptions

            for (let i = 0; i < statusOptionToBeShown.length; i++) {
                let statusData = statusOptions.find((item) => item.candidateStatusCode === statusOptionToBeShown[i])
                statusDropdown.push(statusData)
            }
        }
        return statusDropdown
    }

    const handleTabChange = (index) => {
        setSelectedTab(index);
        let targetSubmitData = submitDataFromModal.find((item) => item.email === candidateList[index].emailID) || {};
        // historyData removed
        // Open accordions when a candidate is selected (Form data closed by default)
        setExpandedAccordions({
            requiredFields: true,
            rightToRepresent: true,
            candidateSubmission: false,
            formData: false
        })

        setSelectedCandidate({
            candidateData: candidateList[index] || null,
            submitData: targetSubmitData,
            submittedByOther: targetSubmitData?.submittedByOther || false
        })
    }


    const handleMandatoryFieldsValidation = (candidateEmail, isAllMandatoryFieldsFilled) => {
        setMandatoryFieldsValidation(prev => ({
            ...prev,
            [candidateEmail]: isAllMandatoryFieldsFilled
        }));
    }

    function convertDate(str) {
        if (str === "") {
            return "";
        }
        const date = new Date(str);

        return DateTime.fromJSDate(date).toISODate();
    }


    const updateSubmitDataState = (field, value) => {
        let allcandidateSubmitData = [...submitDataFromModal];
        let index = allcandidateSubmitData.findIndex(item => item.email === selectedCandidate?.candidateData?.emailID);
        if (field === 'status') {
            if (value) {
                if (submitDataFromModal[index].currentStatus.candidateStatusCode === configJSON.candidateRequisitionStatusCode.SELECTED &&
                    selectedCandidate?.submitData?.candidateRequisitionAttachments?.approvalStatus?.isPending === true
                ) {
                    NotificationManager.error("Cannot move candidate to Selected stage until RTR approval is received.", "Error", 10000);
                    allcandidateSubmitData[index].isStageChanged = false;
                    return
                }
                else if (submitDataFromModal[index].currentStatus.candidateStatusCode === configJSON.candidateRequisitionStatusCode.SELECTED &&
                    selectedCandidate?.submitData?.candidateRequisitionAttachments?.approvalStatus?.isRejected === true
                    && (value.candidateStatusCode !== configJSON.candidateRequisitionStatusCode.APPLICATION_WITHDRAWN ||
                        value.candidateStatusCode !== configJSON.candidateRequisitionStatusCode.CANDIDATE_DECLINED ||
                        value.candidateStatusCode !== configJSON.candidateRequisitionStatusCode.CLIENT_DECLINED
                    )
                ) {
                    NotificationManager.error("Cannot proceed to the next stage as the candidate has already declined the RTR.", "Error", 10000);
                    allcandidateSubmitData[index].isStageChanged = false;
                    return
                }
                setContentLoader(true);
                const prevStatusCode = allcandidateSubmitData[index].status?.candidateStatusCode;
                const prevVals = candidateFieldPrevValues[allcandidateSubmitData[index].email];
                if (prevVals) {
                    if (prevVals.gender !== undefined) {
                        allcandidateSubmitData[index].candidateRequisitionInfoFields.gender = prevVals.gender;
                    }
                    if (prevVals.currentStatus !== undefined) {
                        allcandidateSubmitData[index].candidateRequisitionInfoFields.currentStatus = prevVals.currentStatus;
                    }
                    setCandidateFieldPrevValues(prev => {
                        const newPrev = { ...prev };
                        delete newPrev[allcandidateSubmitData[index].email];
                        return newPrev;
                    });
                }
                allcandidateSubmitData[index].isStageChanged = true;
                let requiredFields = value?.fields || [];
                if (selectedRequisitionInfo.requisitionDetailData.placementType === "Contract") {
                    requiredFields = requiredFields.filter(field => field.altName !== 'salary');
                }
                else {
                    requiredFields = requiredFields.filter(field => field.altName !== 'hourlyPayRate' && field.altName !== 'hourlyMargin' && field.altName !== 'endDate');
                }
                let activityLogsData = {}
                requiredFields.forEach(item => {
                    if (item.altName === "displayDate") {
                        let currentTime = DateTime.now().toISO();
                        activityLogsData[item.altName] = currentTime;
                        allcandidateSubmitData[index].displayDate = currentTime;
                    }
                    else {
                        activityLogsData[item.altName] = '';
                    }
                })
                value.fields = requiredFields;
                allcandidateSubmitData[index].newActivityStatus = {
                    candidateStatusCode: value.candidateStatusCode,
                    candidateStatusCodeId: value._id,
                    activityLogs: activityLogsData
                };
                allcandidateSubmitData[index].status = value;
                allcandidateSubmitData[index].isStatusChange = prevStatusCode !== value.candidateStatusCode;
                const originalCandidate = candidateList.find(c => c.emailID === allcandidateSubmitData[index].email);
                const currentGender = allcandidateSubmitData[index].candidateRequisitionInfoFields.gender;
                const currentStatus = allcandidateSubmitData[index].candidateRequisitionInfoFields.currentStatus;
                const originalGender = originalCandidate?.gender || '';
                const originalStatus = originalCandidate?.currentStatus || '';
                allcandidateSubmitData[index].isFieldChange = (currentGender !== originalGender) || (currentStatus !== originalStatus);
                setSubmitDataFromModal(allcandidateSubmitData);
                setSelectedCandidate({
                    ...selectedCandidate,
                    submitData: allcandidateSubmitData[index]
                })
                setTimeout(() => {
                    setContentLoader(false);
                }, 1500);
            }
        }
        else {
            allcandidateSubmitData[index].newActivityStatus.activityLogs[field] = value;
            if (field === 'submissionStatus') {
                allcandidateSubmitData[index]['submissionType'] = value;
            }
            else { allcandidateSubmitData[index][field] = value; }
            setSubmitDataFromModal(allcandidateSubmitData);
            setSelectedCandidate({
                ...selectedCandidate,
                submitData: allcandidateSubmitData[index]
            })
        }
    }

    const downloadRTRDocx = (rtrLinkdownload) => {
        window.open(rtrLinkdownload, "_blank")
    };

    const handleRTRModalClose = () => {
        setRtrDialogOpen(false);
        setRtrData({
            rtrLinkdownload: '',
            rtrText: ''
        });
    }

    const resendRTREmail = async () => {
        let payload = {
            candidateRequisitionId: selectedCandidate?.submitData?.candidateRequisitionId || '',
            requisitionRecruiterId: selectedCandidate?.submitData?.requisitionRecruiterId || '',
            requisitionDetailId: selectedRequisitionInfo.requisitionDetailData?._id || '',
        }
        setIsApiRunning(prev => ({
            ...prev,
            rtrResending: true
        }));


        try {
            let response = await resendCandidateRequistionAttachments(payload);
            if (response?.status === 200) {
                let allcandidateSubmitData = [...submitDataFromModal];
                let index = allcandidateSubmitData.findIndex(item => item.email === selectedCandidate?.candidateData?.emailID);
                allcandidateSubmitData[index].candidateRequisitionAttachments.approvalStatus = {
                    isPending: true,
                    isApproved: false,
                    isRejected: false,
                }
                setSubmitDataFromModal(allcandidateSubmitData);
                setSelectedCandidate({
                    ...selectedCandidate,
                    submitData: allcandidateSubmitData[index]
                });
                NotificationManager.success("RTR email resent successfully", "Success", 10000);
            }

        } catch (error) {
            console.error("Error resending RTR email:", error);
            NotificationManager.error("Failed to resend RTR email", "Error", 10000);
        } finally {
            setIsApiRunning(prev => ({
                ...prev,
                rtrResending: false
            }));
            handleRTRModalClose();
        }
    }

    // Stable version so hooks depending on it don't re-run each render unnecessarily
    const checkSpocRequired = useCallback(() => {
        const reqDetailData = selectedRequisitionInfo?.requisitionDetailData || {};
        const placementTemplateCode = reqDetailData?.placementTemplateCode || "";
        let spocConfig = reqDetailData?.spocData?.spocSubmissionConfig || [];
        spocConfig = spocConfig.filter(item => item.placementTemplateCode === placementTemplateCode);
        return !!(reqDetailData?.spocData?.isEmailRequired && reqDetailData?.spocData?.isActive && spocConfig.length > 0);
    }, [selectedRequisitionInfo?.requisitionDetailData]);

    const hasResumeData = useCallback((candidateEmail) => {
        if (!candidateEmail) return false;

        const candidateSubmitData = submitDataFromModal.find(item => item.email === candidateEmail);
        const hasResumeInSubmitData = candidateSubmitData?.resumeLink && candidateSubmitData.resumeLink.length > 0;
        const hasResumeInCandidate = candidateSubmitData?.candidateCompleteResume?.resumeLink;
        const hasUploadedResume = resumeDataForCandidate[candidateEmail];

        return hasResumeInSubmitData || hasResumeInCandidate || hasUploadedResume;
    }, [submitDataFromModal, resumeDataForCandidate]);

   const isCandidateComplete = useCallback((candidate) => {
        
        if (!candidate.isFieldChange && !candidate.isStatusChange && !candidate.isResumeUpdated && !candidate.isResumeUpdating) {
            return false;
        }

        if (!candidate.candidateRequisitionInfoFields?.gender || !candidate.candidateRequisitionInfoFields?.currentStatus) {
            return false;
        }

        const mandatoryFieldsValid = mandatoryFieldsValidation[candidate.email];
        if (mandatoryFieldsValid !== undefined && mandatoryFieldsValid !== true) {
            return false;
        }
        if (candidate.isStatusChange && mandatoryFieldsValid !== true) {
            return false;
        }

        const candidateResumeVaild = candidate.email;
        const hasResume = hasResumeData(candidateResumeVaild);
        if (!hasResume) {
            return false;
        }

       
        const submissionData = candidate.candidateSubmissionData;
        if (submissionData && !submissionData._id) {
            const details = submissionData.details || [];

            if (details.length > 0) {
                const hasEmptyValues = details.some(detail => {
                    const value = detail.value;
                    const subCode = detail.subCode;

                    if (value === null || value === undefined) {
                        return true;
                    }

                    if (typeof value === 'string' && value.trim() === '') {
                        return true;
                    }

                    if (Array.isArray(value) && value.length === 0) {
                        return true;
                    }

                    if (typeof value === 'object' && !Array.isArray(value)) {
                        const allowedSubmissionCodes = [
                            candidateSubmissionConfig.currenthourlyrate,
                            candidateSubmissionConfig.currentdailyrate,
                            candidateSubmissionConfig.currentmonthlyrate,
                            candidateSubmissionConfig.currentyearlyrate,
                            candidateSubmissionConfig.expectedhourlyrate,
                            candidateSubmissionConfig.expecteddailyrate,
                            candidateSubmissionConfig.expectedmonthlyrate,
                            candidateSubmissionConfig.expectedyearlyrate
                        ];

                        if (subCode === candidateSubmissionConfig.currentCTC || subCode === candidateSubmissionConfig.expectedCTC || allowedSubmissionCodes.includes(subCode)) {
                            if (!value.amount || value.amount === '' ||
                                !value.currency || value.currency === '' ||
                                !value.unit || value.unit === '') {
                                return true;
                            }
                        } else {
                            if (Object.keys(value).length > 0 &&
                                Object.values(value).every(v => v === '' || v === null || v === undefined)) {
                                return true;
                            }
                        }
                    }

                    return false;
                });

                if (hasEmptyValues) {
                    return false;
                }
            }
        }


        if (candidate.isStatusChange) {
            const newStatus = candidate.status;
            const newActivityLogs = candidate.newActivityStatus?.activityLogs;

            if (newStatus && newActivityLogs) {
                let requiredFields = newStatus.fields || [];

                
                if (selectedRequisitionInfo?.requisitionDetailData?.placementType === "Contract") {
                    requiredFields = requiredFields.filter(field => field.altName !== 'salary');
                } else {
                    requiredFields = requiredFields.filter(field => field.altName !== 'hourlyPayRate' && field.altName !== 'hourlyMargin' && field.altName !== 'endDate');
                }


                const allMandatoryFieldsFilled = requiredFields.every(field => {
                    if (!field.isMandatory) return true; 

                    const value = newActivityLogs[field.altName];


                    if (value === null || value === undefined || value === '') {
                        return false;
                    }


                    if (typeof value === 'string' && value.trim() === '') {
                        return false;
                    }

                    return true;
                });

                if (!allMandatoryFieldsFilled) {
                    return false;
                }


                if (newStatus.candidateStatusCode === configJSON.candidateRequisitionStatusCode.SUBMITTED) {
                    const submissionStatusValue = newActivityLogs.submissionStatus;
                    const hasSubmissionTypes = newStatus.submissionType && newStatus.submissionType.length > 0;

                    if (hasSubmissionTypes) {
                        if (!submissionStatusValue || submissionStatusValue === '') {
                            return false;
                        }


                        const validSubmissionTypes = newStatus.submissionType.map(type => type.type);
                        if (!validSubmissionTypes.includes(submissionStatusValue)) {
                            return false;
                        }
                    }
                }
            }
        } else {

            const currentActivityLogs = candidate.currentActivityStatus?.activityLogs;
            const currentStatus = candidate.currentStatus;

            if (currentStatus && currentActivityLogs) {
                let requiredFields = currentStatus.fields || [];


                if (selectedRequisitionInfo?.requisitionDetailData?.placementType === "Contract") {
                    requiredFields = requiredFields.filter(field => field.altName !== 'salary');
                } else {
                    requiredFields = requiredFields.filter(field => field.altName !== 'hourlyPayRate' && field.altName !== 'hourlyMargin' && field.altName !== 'endDate');
                }


                const allMandatoryFieldsFilled = requiredFields.every(field => {
                    if (!field.isMandatory) return true;

                    const value = currentActivityLogs[field.altName];

                    if (value === null || value === undefined || value === '') {
                        return false;
                    }

                    if (typeof value === 'string' && value.trim() === '') {
                        return false;
                    }

                    return true;
                });

                if (!allMandatoryFieldsFilled) {
                    return false;
                }

                if (currentStatus.candidateStatusCode === configJSON.candidateRequisitionStatusCode.SUBMITTED) {
                    const submissionStatusValue = currentActivityLogs.submissionStatus;
                    const hasSubmissionTypes = currentStatus.submissionType && currentStatus.submissionType.length > 0;

                    if (hasSubmissionTypes) {
                        if (!submissionStatusValue || submissionStatusValue === '') {
                            return false;
                        }

                        const validSubmissionTypes = currentStatus.submissionType.map(type => type.type);
                        if (!validSubmissionTypes.includes(submissionStatusValue)) {
                            return false;
                        }
                    }
                }
            }
        }


        const spocRequired = checkSpocRequired();

        if (!candidate.candidateReqExist) {
            const altContactsArr = candidate.candidateSubmissionData?.altContacts || [];
            const hasActualSubmissionFields = candidate.candidateSubmissionData?.details?.length > 0;

            if (hasActualSubmissionFields) {
                if ((isAdditionalSpocRequiredGlobal || !spocRequired) && altContactsArr.length === 0) {
                    return false;
                }

                if (hasActiveSubmissionConfig && isAdditionalSpocRequiredGlobal && sharedAdditionalSpoc.length === 0) {
                    return false;
                }
            } else {
                if (isAdditionalSpocRequiredGlobal && altContactsArr.length === 0) {
                    return false;
                }
            }
        }

        if (candidate.isResumeUpdating) {
            return true;
        }

        return true;
    }, [mandatoryFieldsValidation, checkSpocRequired, isAdditionalSpocRequiredGlobal, hasActiveSubmissionConfig, sharedAdditionalSpoc, hasResumeData, selectedRequisitionInfo?.requisitionDetailData?.placementType]);

    const isEmpty = (val) => {
        if (val === undefined || val === null) return true;
        if (typeof val === 'string') return val.trim() === '';
        if (Array.isArray(val)) return val.length === 0;
        if (typeof val === 'object') {
            // Special handling for location objects (CSF08)
            if (val.hasOwnProperty('city') || val.hasOwnProperty('state') || val.hasOwnProperty('country')) {
                // For location objects, consider empty if all location fields are empty
                const city = val.city || '';
                const state = val.state || '';
                const country = val.country || '';
                return city.trim() === '' && state.trim() === '' && country.trim() === '';
            }
            // For other objects, check if empty or all values are empty
            return Object.keys(val).length === 0 || Object.values(val).every(v => isEmpty(v));
        }
        return false; // For numbers, booleans, etc.
    }
    // Stable version so hooks depending on it don't re-run each render unnecessarily
    // checkSpocRequired moved above isCandidateComplete

    // Resume upload functionality
    const handleDataFromModal = (data, candidateEmail) => {
        const newResumeLink = data && data[0] && (data[0].URL || data[0].url || data[0].link);

        if (!newResumeLink) return;

        // Update the resume data for the specific candidate (store URL string)
        setResumeDataForCandidate(prev => ({
            ...prev,
            [candidateEmail]: newResumeLink
        }));

        // Update submitDataFromModal with the new resume link object
        let allCandidateSubmitData = [...submitDataFromModal];
        let index = allCandidateSubmitData.findIndex(item => item.email === candidateEmail);
        if (index !== -1) {
            // Ensure existing resumeLink is an array of objects
            const existing = Array.isArray(allCandidateSubmitData[index].resumeLink) ? allCandidateSubmitData[index].resumeLink : [];
            const normalized = existing.map(el => {
                if (!el) return null;
                if (typeof el === 'object' && typeof el.link === 'string') return { link: el.link.trim(), uploadedDate: el.uploadedDate || DateTime.now().toISO() };
                if (typeof el === 'string') return { link: el.trim(), uploadedDate: DateTime.now().toISO() };
                return null;
            }).filter(Boolean);

            // Append new uploaded link as the newest entry
            normalized.push({ link: newResumeLink, uploadedDate: DateTime.now().toISO() });

            // Keep only the latest 2 resume versions
            const finalResumeObject = normalized.length > 2 ? normalized.slice(normalized.length - 2) : normalized;

            allCandidateSubmitData[index].resumeLink = finalResumeObject;
            allCandidateSubmitData[index].isResumeUpdated = true;
            allCandidateSubmitData[index].isResumeUpdating = false;

            setSubmitDataFromModal(allCandidateSubmitData);

            // Update selected candidate if it's the current one
            if (selectedCandidate?.candidateData?.emailID === candidateEmail) {
                setSelectedCandidate(prev => ({
                    ...prev,
                    submitData: allCandidateSubmitData[index]
                }));
            }
        }
    };

    const handleResumeLoader = (loader, candidateEmail) => {
        setIsResumeUploadLoader(loader);


        if (loader) {
            let allCandidateSubmitData = [...submitDataFromModal];
            let index = allCandidateSubmitData.findIndex(item => item.email === candidateEmail);
            if (index !== -1) {
                allCandidateSubmitData[index].isResumeUpdating = true;
                setSubmitDataFromModal(allCandidateSubmitData);


                if (selectedCandidate?.candidateData?.emailID === candidateEmail) {
                    setSelectedCandidate(prev => ({
                        ...prev,
                        submitData: allCandidateSubmitData[index]
                    }));
                }
            }
        } else {

            let allCandidateSubmitData = [...submitDataFromModal];
            let index = allCandidateSubmitData.findIndex(item => item.email === candidateEmail);
            if (index !== -1) {
                allCandidateSubmitData[index].isResumeUpdating = false;
                setSubmitDataFromModal(allCandidateSubmitData);


                if (selectedCandidate?.candidateData?.emailID === candidateEmail) {
                    setSelectedCandidate(prev => ({
                        ...prev,
                        submitData: allCandidateSubmitData[index]
                    }));
                }
            }
        }
    };

    const handleUploadResumeClick = () => {
        if (!selectedCandidate?.candidateData?.emailID) {
            NotificationManager.error('No candidate selected', 'Error', 10000);
            return;
        }

        if (!selectedRequisitionInfo?.requisitionDetailData?.reqreferenceId) {
            NotificationManager.error('Please select a requisition first', 'Error', 10000);
            return;
        }

        setShowResumeModal(true);
    };

    // Callback to receive formatted submission data from SubmissionComp
    const handleFormattedSubmissionData = useCallback((formattedData) => {
        setFormattedSubmissionData(prev => ({
            ...prev,
            [selectedCandidate?.candidateData?.emailID]: formattedData
        }));
    }, [selectedCandidate]);

    const handleViewResumeClick = () => {
        const candidateEmail = selectedCandidate?.candidateData?.emailID;
        if (!candidateEmail) return;


        const resumeLink = resumeDataForCandidate[candidateEmail] ||
            getCurrentResumeLink(candidateEmail);

        if (resumeLink) {
            window.open(resumeLink, "_blank");
        } else {
            NotificationManager.error('No resume available for this candidate', 'Error', 10000);
        }
    };

    const getResumeIcon = (candidateEmail) => {
        if (!candidateEmail) return null;
        let extension = null;

        // Helper to get latest resume link from arrays/objects
        const candidateSubmitData = submitDataFromModal.find(item => item.email === candidateEmail);
        
        // Check if resume was updated for this candidate
        const isResumeUpdated = candidateSubmitData?.isResumeUpdated || resumeDataForCandidate[candidateEmail];

        // 1) Prefer explicit extension from candidate data if present
        if (selectedCandidate?.candidateData?.emailID === candidateEmail && selectedCandidate?.candidateData?.extension) {
            extension = selectedCandidate.candidateData.extension.toLowerCase();
        } else if (candidateSubmitData?.candidateCompleteResume?.extension) {
            extension = candidateSubmitData.candidateCompleteResume.extension.toLowerCase();
        } else {
            // 2) Use the newest resume link (by uploadedDate when available)
            const latest = getCurrentResumeLink(candidateEmail);
            if (latest && typeof latest === 'string' && latest.includes('.')) {
                try {
                    extension = latest.split('.').pop().toLowerCase();
                } catch (error) {
                    console.error('Error extracting file extension:', error);
                }
            }
        }

        // Use green color if resume was updated, otherwise use original colors
        const iconColor = isResumeUpdated ? '#4caf50' : null; // Green color for updated resumes

        if (extension === 'pdf') {
            return <PictureAsPdfIcon style={{ color: iconColor || '#d32f2f', marginRight: '8px' }} />;
        } else if (extension === 'doc' || extension === 'docx') {
            return <DescriptionIcon style={{ color: iconColor || '#1976d2', marginRight: '8px' }} />;
        }

        return null;
    };



    const getCurrentResumeLink = (candidateEmail) => {
        if (!candidateEmail) return null;
        // 1) If user uploaded new resume in this session, prefer that (it's the latest)
        const uploadedResume = resumeDataForCandidate[candidateEmail];
        if (uploadedResume) return uploadedResume;

        const candidateSubmitData = submitDataFromModal.find(item => item.email === candidateEmail);
        if (!candidateSubmitData) return null;

        // Helper to select the latest link when resumeLink is an array
        const selectLatestResume = (raw) => {
            if (!raw) return null;
            if (!Array.isArray(raw)) {
                if (typeof raw === 'object' && raw.link) return raw.link;
                if (typeof raw === 'string') return raw;
                return null;
            }

            const normalized = raw.map(el => {
                if (!el) return null;
                if (typeof el === 'object' && el.link) return { link: el.link, uploadedDate: el.uploadedDate || null };
                if (typeof el === 'string') return { link: el, uploadedDate: null };
                return null;
            }).filter(Boolean);

            if (normalized.length === 0) return null;

            // Prefer ones that contain uploadedDate and pick the newest
            const withDates = normalized.filter(n => n.uploadedDate);
            if (withDates.length > 0) {
                withDates.sort((a, b) => {
                    try {
                        return DateTime.fromISO(b.uploadedDate).toMillis() - DateTime.fromISO(a.uploadedDate).toMillis();
                    } catch (e) {
                        return 0;
                    }
                });
                return withDates[0].link;
            }

            // Fallback: assume last element is newest
            return normalized[normalized.length - 1].link;
        }

        // 2) Try to pick from candidate.requisition resumeLink array
        const rawLink = candidateSubmitData?.resumeLink;
        const latestFromArray = selectLatestResume(rawLink);
        if (latestFromArray) return latestFromArray;

        // 3) Fallback to candidateCompleteResume fields
        const candidateResumeUrl = candidateSubmitData?.candidateCompleteResume?.resumeUrl || candidateSubmitData?.candidateCompleteResume?.resumeLink;
        if (candidateResumeUrl && typeof candidateResumeUrl === 'string') return candidateResumeUrl;

        return null;
    };


    const handleBulkSubmit = async () => {
        if (submitDataFromModal.length === 0) {
            NotificationManager.error('No candidate data available for submission', 'Error', 10000);
            return;
        }

        // Ensure all candidates have submit data
        const missingData = candidateList.filter(candidate =>
            !submitDataFromModal.some(item => item.email === candidate.emailID)
        );

        if (missingData.length > 0) {
            NotificationManager.error(`Missing submission data for: ${missingData.map(c => c.name || c.emailID).join(', ')}`, 'Error', 10000);
            return;
        }
        const candidatesWithoutExistingSubmissions = submitDataFromModal.filter(item =>
            !item.candidateReqExist || (item.candidateSubmissionData && !item.candidateSubmissionData._id)
        );

        if (hasActiveSubmissionConfig && isAdditionalSpocRequiredGlobal &&
            candidatesWithoutExistingSubmissions.length > 0 && sharedAdditionalSpoc.length === 0) {
            NotificationManager.error('Additional SPOC Mail ID is required (no emails provided)', 'Error', 10000);
            return;
        }

        for (let i = 0; i < submitDataFromModal.length; i++) {
            const item = submitDataFromModal[i];
            // --- Resume validation: must have resume before submit ---
            const candidateEmail = item.email;
            const hasResume = hasResumeData(candidateEmail);
            if (!hasResume) {
                NotificationManager.error(`Please upload a resume for ${item.name} before submitting.`, "Error", 10000);
                return;
            }
            if (!isCandidateComplete(item)) {
                NotificationManager.error(`Please complete all required fields for ${item.name}`, "Error", 10000);
                return;
            }


            if (!item.candidateRequisitionInfoFields?.gender || !item.candidateRequisitionInfoFields?.currentStatus) {
                NotificationManager.error(`Please fill Gender and Current Status for ${item.name}`, "Error", 10000);
                return;
            }


            const mandatoryFieldsValid = mandatoryFieldsValidation[item.email];

            if (mandatoryFieldsValid !== undefined && mandatoryFieldsValid !== true) {
                NotificationManager.error(`Please fill all mandatory fields for ${item.name}`, "Error", 10000);
                return;
            }

            if (item.isStatusChange && mandatoryFieldsValid !== true) {
                NotificationManager.error(`Please fill all mandatory activity fields for ${item.name}`, "Error", 10000);
                return;
            }

            // Check candidateSubmissionData validation
            const submissionData = item.candidateSubmissionData;
            if (submissionData && !submissionData._id) {
                // If candidateSubmissionData exists but doesn't have _id, check if all required fields are filled
                const details = submissionData.details || [];
                const hasEmptyValues = details.some(detail => {
                    const value = detail.value;
                    // Check if value is empty (null, undefined, empty string, or empty array)
                    return value === null || value === undefined ||
                        (typeof value === 'string' && value.trim() === '') ||
                        (Array.isArray(value) && value.length === 0);
                });

                if (hasEmptyValues) {
                    NotificationManager.error(`Please fill all required candidate submission fields for ${item.name}`, "Error", 10000);
                    return;
                }
            }

            if (item.isStatusChange) {
                const newStatus = item.status;
                const newActivityLogs = item.newActivityStatus?.activityLogs;
                if (newStatus && newActivityLogs) {
                    const requiredFields = newStatus.fields || [];
                    const allNewFieldsFilled = requiredFields.every(field => {
                        const value = newActivityLogs[field.altName];
                        return value !== null && value !== undefined && value !== '';
                    });
                    if (!allNewFieldsFilled) {
                        NotificationManager.error(`Please fill all required activity fields for ${item.name}`, "Error", 10000);
                        return;
                    }
                }
            }
        }

        setIsSubmitting(true);
        let candidateActionArr = [];

        for (let i = 0; i < submitDataFromModal.length; i++) {
            const item = submitDataFromModal[i];
            let requiredData = {
                candidateReqExist: item.candidateReqExist || false,
                candidateRequisitionId: item.candidateRequisitionId || '',
                candidateRequisitionInfoFields: item.candidateRequisitionInfoFields || {},
                candidateResumeDetailsId: item.candidateDetailId || '',
                currentActivityStatus: item.currentActivityStatus || {},
                currentStatus: {
                    candidateStatusCode: item.currentStatus?.candidateStatusCode || '',
                    candidateStatusCodeId: item.currentStatus?._id || '',
                },
                email: item.email || '',
                name: item.name || '',
                endDate: item.endDate || '',
                eventDate: item.eventDate || '',
                displayDate: item.displayDate || '',
                hourlyMargin: item.hourlyMargin || '',
                hourlyPayRate: item.hourlyPayRate || '',
                isStageChanged: item.isStageChanged || false,
                isStageValueUpdated: item.isStageValueUpdated || false,
                isResumeUpdated: item.isResumeUpdated || false,
                notes: item.notes || '',
                phone: item.phone || '',
                recruiterId: item.recruiterId || '',
                reqreferenceId: item.reqreferenceId || '',
                requisitionDetailId: item.requisitionDetailId || '',
                requisitionId: item.requisitionId || '',
                requisitionLeaderId: item.requisitionLeaderId || '',
                requisitionRecruiterId: item.requisitionRecruiterId || '',
                requisitionTeamLeaderId: item.requisitionTeamLeaderId || '',
                recruitmentLeaderId: item.recruitmentLeaderId || '',
                salary: item.salary || '',
                status: {
                    candidateStatusCode: item.status?.candidateStatusCode || '',
                    candidateStatusCodeId: item.status?._id || '',
                },
                submissionType: item.submissionType || '',
                teamId: item.teamId || '',
                teamLeaderId: item.teamLeaderId || '',
                isRTRApprovalPending: item.candidateRequisitionAttachments?.approvalStatus?.isPending || false,
                lastEventStatusCreatedBy: userRecords,
                isRTRDeclined: false,
            };
            if (item.isStageChanged) {
                requiredData.currentActivityStatus = item.newActivityStatus
            }
            else { requiredData.currentActivityStatus = item.currentActivityStatus }
            let activityLogsData = requiredData.currentActivityStatus?.activityLogs || {};
            for (let logKey in activityLogsData) {
                if(logKey === 'eventDate' || logKey === 'endDate' || logKey === "startedDate") {
                    let updateDateValue = convertDate(activityLogsData[logKey]);
                    activityLogsData[logKey] = updateDateValue;
                    if(logKey in requiredData) {
                        requiredData[logKey] = updateDateValue;
                    }
                }
            }
            requiredData.currentActivityStatus.activityLogs = activityLogsData;
            if (item.candidateRequisitionAttachments?.approvalStatus?.isRejected === true) {
                requiredData.isRTRDeclined = true;
            }
            // Use formatted submission data if available, otherwise use raw data
            const candidateEmailForSubmission = item.email;
            const formattedData = formattedSubmissionData[candidateEmailForSubmission];
            requiredData.candidateSubmissionData = formattedData || item.candidateSubmissionData || null;

            // Process resume link updates
            const candidateEmail = item.email;

            // Gather links from various possible shapes: array of objects, array of strings, single string, or resumeDetails
            const newResumeLink = resumeDataForCandidate[candidateEmail];
            let collectedLinks = [];

            // 1) Existing resumeLink on the candidate requisition (could be array or string)
            const existingRaw = item.resumeLink;
            if (Array.isArray(existingRaw)) {
                existingRaw.forEach(el => {
                    if (!el) return;
                    if (typeof el === 'object' && typeof el.link === 'string' && el.link.trim()) {
                        collectedLinks.push({ link: el.link.trim(), uploadedDate: el.uploadedDate || DateTime.now().toISO() });
                    } else if (typeof el === 'string' && el.trim()) {
                        collectedLinks.push({ link: el.trim(), uploadedDate: DateTime.now().toISO() });
                    }
                });
            } else if (typeof existingRaw === 'string' && existingRaw.trim()) {
                collectedLinks.push({ link: existingRaw.trim(), uploadedDate: item.candidateCompleteResume?.lastUploadDate || DateTime.now().toISO() });
            }

            // 2) If no links found on requisition, fall back to resumeDetails.resumeUrl
            if (collectedLinks.length === 0 && item.candidateCompleteResume?.resumeUrl) {
                collectedLinks.push({ link: item.candidateCompleteResume.resumeUrl, uploadedDate: item.candidateCompleteResume?.lastUploadDate || DateTime.now().toISO() });
            }

            // 3) If user uploaded a new resume in this session, append it (newest last)
            if (newResumeLink) {
                collectedLinks.push({ link: newResumeLink, uploadedDate: DateTime.now().toISO() });
            }

            // Deduplicate by link, preserve order
            const seen = new Set();
            collectedLinks = collectedLinks.filter(obj => {
                if (!obj || !obj.link) return false;
                if (seen.has(obj.link)) return false;
                seen.add(obj.link);
                return true;
            });

            // Keep only the latest 2 resume versions (most recent are at the end)
            if (collectedLinks.length > 2) {
                collectedLinks = collectedLinks.slice(collectedLinks.length - 2);
            }

            if (collectedLinks.length > 0) {
                requiredData.resumeLink = collectedLinks;
            }

            // Ensure isResumeUpdated is true in the payload whenever resume data was changed or uploaded
            requiredData.isResumeUpdated = !!(resumeDataForCandidate[candidateEmail] || item.isResumeUpdated);

            let spocRequired = checkSpocRequired()
            requiredData.isSpocRequired = spocRequired;

            let requiredSubmissionData = item.candidateSubmissionData || {};
            if (!item.candidateReqExist) {
                if ((selectedRequisitionInfo?.requisitionDetailData.spocData?.isActive && selectedRequisitionInfo?.requisitionDetailData.spocData?.isEmailRequired) ||
                    (selectedRequisitionInfo?.requisitionDetailData?.clientData?.isEmailRequired && selectedRequisitionInfo?.requisitionDetailData?.clientData?.isActive)) {
                    let details = requiredSubmissionData?.details || [];
                    if (Array.isArray(details)) {
                        for (let detail of details) {
                            if (isEmpty(detail.value)) {
                                NotificationManager.error(`Please fill the required candidate submission field for ${item.name}`, "Error", 10000);
                                setIsSubmitting(false);
                                return;
                            }
                        }
                    }
                    // Additional SPOC validation: only required when there are actual submission fields OR explicitly required
                    // Skip SPOC validation if candidateSubmissionData already has an _id (already submitted)
                    const altContactsArr = requiredSubmissionData?.altContacts || [];
                    const hasActualSubmissionFields = details.length > 0;
                    const hasExistingSubmissionData = requiredSubmissionData && requiredSubmissionData._id;

                    // Only enforce SPOC requirements if there are actual submission fields OR explicitly required, and no existing submission data
                    if (hasActualSubmissionFields && !hasExistingSubmissionData) {
                        if ((isAdditionalSpocRequiredGlobal || (!spocRequired && !item.candidateReqExist)) && altContactsArr.length === 0) {
                            NotificationManager.error(`Please fill the Additional SPOC Mail ID for ${item.name}`, 'Error', 10000);
                            setIsSubmitting(false);
                            return;
                        }
                    } else if (!hasExistingSubmissionData) {
                        // For cases without submission fields (like contractual without templates), only require SPOC if explicitly set and no existing data
                        if (isAdditionalSpocRequiredGlobal && altContactsArr.length === 0) {
                            NotificationManager.error(`Please fill the Additional SPOC Mail ID for ${item.name}`, 'Error', 10000);
                            setIsSubmitting(false);
                            return;
                        }
                    }
                }
                if (requiredData.submissionType === "External") {
                    requiredData.isSubmissionMailSend = true;
                }
                else {
                    requiredData.isSubmissionMailSend = false
                }

            }

            candidateActionArr.push(requiredData);

        }
        let payload = {
            recruitmentpartnerId: recruitmentpartnerId || '',
            senderId: userId || '',
            candidateActionArr: candidateActionArr,
        }
        
        try {
            let response = await candidateBulkAction(payload);
            if (response.status === 200) {
                if (sourcePage === 'Activity') {
                    moveCandidate(candidateActionArr)
                }
                NotificationManager.success(response.data.message, "Success", 10000);
                handleCloseModal()
            }
        } catch (error) {
            console.error("Error during bulk submit:", error);
            NotificationManager.error("Failed to submit candidates", "Error", 10000);
        } finally {
            setIsSubmitting(false);
        }
    }

    const getCandidateStatusIcon = (candidate) => {
        const submitData = submitDataFromModal.find(item => item.email === candidate.emailID);

        if (!submitData) {
            return null;
        }

        if (submitData?.submittedByOther) {
            return <span className="incompleteIcon_bulkSubmit">!</span>;
        }

        // Check if resume was specifically updated for enhanced visual feedback
        const isResumeUpdated = submitData?.isResumeUpdated || resumeDataForCandidate[candidate.emailID];

        if (submitData.candidateReqExist &&
            !submitData.isFieldChange &&
            !submitData.isStatusChange &&
            !submitData.isResumeUpdated &&
            !submitData.isResumeUpdating) {
            return null;
        }

        if (submitData.candidateReqExist &&
            (submitData.isFieldChange || submitData.isStatusChange || submitData.isResumeUpdated) &&
            !isCandidateComplete(submitData)) {
            return <span className="incompleteIcon_bulkSubmit">!</span>;
        }

        if (isCandidateComplete(submitData) || submitData?.isResumeUpdating) {
            
            if (isResumeUpdated) {
                return (
                    <span className="completedIcon_bulkSubmit">✓</span>
                );
            }

            return <span className="completedIcon_bulkSubmit">✓</span>;
        }

        return <span className="incompleteIcon_bulkSubmit">!</span>;
    };



    useEffect(() => {
        if (candidateList.length === 0) {
            setOpenBukSubmitModal(false);
        } else if (candidateList.length > 0 && (!selectedCandidate.candidateData || selectedTab >= candidateList.length)) {
            setSelectedCandidate({
                candidateData: candidateList[0] || null,
                submitData: {},
                submittedByOther: false,
            });
            setSelectedTab(0);
            // Clear formatted submission data when candidate list changes
            setFormattedSubmissionData({});
        }
    }, [candidateList, setOpenBukSubmitModal, selectedCandidate.candidateData, selectedTab]);

    useEffect(() => {
        if (candidateList.length > 0 && candidateList[selectedTab]) {
            let targetSubmitData = submitDataFromModal.find((item) => item.email === candidateList[selectedTab].emailID) || {};

            // Only update selectedCandidate, don't reset accordions when submitDataFromModal changes
            setSelectedCandidate({
                candidateData: candidateList[selectedTab] || null,
                submitData: targetSubmitData,
                submittedByOther: targetSubmitData?.submittedByOther || false
            });

            // Clear formatted submission data for the previous candidate
            setFormattedSubmissionData(prev => {
                const newData = { ...prev };
                // Keep only data for the current candidate
                const currentEmail = candidateList[selectedTab]?.emailID;
                if (currentEmail) {
                    return { [currentEmail]: newData[currentEmail] };
                }
                return {};
            });
        }
    }, [selectedTab, candidateList, submitDataFromModal]);

    // Separate useEffect to handle accordion state only when tab or candidateList changes
    useEffect(() => {
        if (candidateList.length > 0 && candidateList[selectedTab]) {
            // Auto-expand accordions when candidate is selected (Form data closed by default)
            setExpandedAccordions({
                requiredFields: true,
                rightToRepresent: true,
                candidateSubmission: false,
                formData: false
            });
        }
    }, [selectedTab, candidateList]); // Removed submitDataFromModal from dependencies

  useEffect(() => {
    if (candidateList.length === 0) {
        setIsSubmitDisabled(true);
        return;
    }

    if (submitDataFromModal.length === 0) {
        setIsSubmitDisabled(true);
        return;
    }

    const allCandidatesHaveSubmitData = candidateList.every(candidate => 
        submitDataFromModal.some(item => item.email === candidate.emailID)
    );
    
    if (!allCandidatesHaveSubmitData) {
        setIsSubmitDisabled(true);
        return;
    }

    const allCandidatesComplete = candidateList.every(candidate => {
        const submitData = submitDataFromModal.find(item => item.email === candidate.emailID);
        if (!submitData) return false;
        
        
        return isCandidateComplete(submitData);
    });

    setIsSubmitDisabled(!allCandidatesComplete);

}, [candidateList, submitDataFromModal, isCandidateComplete, mandatoryFieldsValidation, resumeDataForCandidate, hasResumeData]);

    const handleFetchRequisition = () => {
        const reqId = requisitionIdInput?.trim();

        if (!reqId) {
            NotificationManager.error(
                'Please enter a requisition ID',
                'Error',
                4500
            );
            return;
        }

        fetchRequisitionData(reqId);
    };


    useEffect(() => {
        if (requisitionId && !hasFetchedRequisitionRef.current) {
            setEnableSkeleton(true);
            hasFetchedRequisitionRef.current = true;
            setRequisitionIdInput(requisitionId);
            fetchRequisitionData();
        }
    }, [])

    return (
        <>
            <Dialog
                open={openBukSubmitModal}
                onClose={() => handleCloseModal()}
                maxWidth="xl"
                fullScreen
            >
                <DialogTitle className='dialogTitleContainer_bulkSubmit'>
                    {!editCandidateStageToggle ?
                        <>
                            <div className="leftSection_bulkSubmit">
                                <Settings className="bulkSubmitIcon" />
                                <div className="titleTextContainer_bulkSubmit">
                                    <span className="mainTitle_bulkSubmit">{candidates.length > 1 ? 'Bulk Candidate Submission' : 'Candidate Submission'}</span>
                                    <span className="subTitle_bulkSubmit">Configure and submit multiple candidates</span>
                                </div>
                                <div className="candidatesBadge_bulkSubmit">
                                    {candidates.length} candidates
                                </div>
                            </div>
                            <div className="rightSection_bulkSubmit">
                                <button className="closeButton_bulkSubmit" onClick={() => handleCloseModal()}>
                                    ✕
                                </button>
                            </div>
                        </>
                        :
                        <div className='reviewStagesHeader_bulkSubmit'>
                            <Visibility />
                            <span>Review Stages</span>
                        </div>
                    }
                </DialogTitle>
                <DialogContent className="dialogContent_bulkSubmit">
                    {enableSkeleton ?
                        <BulkSubmitModalSkeleton />
                        :
                        <>
                            {editCandidateStageToggle ?
                                <ReviewStages
                                    setEditCandidateStageToggle={setEditCandidateStageToggle}
                                    candidate={selectedCandidate}
                                    candidateRequisitionStatus={candidateRequisitionStatus}
                                    submitDataFromModal={submitDataFromModal}
                                    recruitmentpartnerId={recruitmentpartnerId}
                                    userId={userId}
                                    setSelectedCandidate={setSelectedCandidate}
                                    setSubmitDataFromModal={setSubmitDataFromModal}
                                    handleCloseModal={handleCloseModal}
                                    candidateList={candidateList}
                                    setCandidateList={setCandidateList}
                                    userType={userType}
                                    sourcePage={sourcePage}
                                    moveCandidate={moveCandidate}
                                    checkSpocRequired={checkSpocRequired}
                                    requisitionDetailData={selectedRequisitionInfo.requisitionDetailData || {}}
                                />

                                :
                                <>
                                    <div className="globalSettings_bulkSubmit">
                                        <div className="globalSettingsRow_bulkSubmit">
                                            <div className="settingsField_bulkSubmit">
                                                <label className="fieldLabel_bulkSubmit">Requisition ID</label>
                                                <div className="requisitionInputWrapper">
                                                    <TextField
                                                        className="requisitionInput"
                                                        placeholder="Enter requisition ID"
                                                        variant="outlined"
                                                        size="small"
                                                        value={requisitionIdInput}
                                                        onChange={(e) => {
                                                            const newValue = e.target.value;
                                                            setRequisitionIdInput(newValue);
                                                        }}
                                                        disabled={isRequisitionIdLocked}
                                                        fullWidth
                                                        InputProps={{
                                                            endAdornment: (
                                                                <>
                                                                    {isAPiRunning.reqruiredRequisitionInfoFetch ? <CircularProgress color="inherit" size={20} /> : null}
                                                                </>
                                                            ),
                                                        }}
                                                    />
                                                    {
                                                        sourcePage !== 'Activity' && <button
                                                            className="fetchRequisitionButton"
                                                            onClick={handleFetchRequisition}
                                                            disabled={
                                                                isFetchingRequisition ||
                                                                isRequisitionIdLocked ||
                                                                !requisitionIdInput?.trim() ||
                                                                (lastFetchedRequisitionInput && requisitionIdInput.trim() === lastFetchedRequisitionInput)
                                                            }
                                                        >
                                                            {isFetchingRequisition ? (
                                                                <CircularProgress size={20} color="inherit" />
                                                            ) : (
                                                                <ArrowSubmit className="arrowIcon" />
                                                            )}
                                                        </button>
                                                    }
                                                    
                                                </div>
                                            </div>
                                            {sourcePage !== 'Activity' && (
                                                <div className="settingsField_bulkSubmit">
                                                    <label className="fieldLabel_bulkSubmit">Select Recruiter</label>
                                                    <Autocomplete
                                                        className="autocomplete_bulkSubmit"
                                                        options={selectedRequisitionInfo.recruiterRquisitionList || []}
                                                        value={selectedRequisitionInfo.recruiterRequisitionData}
                                                        loading={isAPiRunning.recruiterListFetching}
                                                        onChange={isRecruiterIdLocked ? undefined : (e, val) => handleRecruiterChange(e, val)}
                                                        isOptionEqualToValue={(option, value) => option?.recruiterData?.email === value?.recruiterData?.email}
                                                        getOptionLabel={(option) => option?.recruiterData?.email || ''}
                                                        onFocus={() => selectedRequisitionInfo.recruiterRquisitionList.length === 0 &&
                                                            Object.keys(selectedRequisitionInfo.requisitionDetailData).length > 0 ?
                                                            fetchRecruiterListData(selectedRequisitionInfo.requisitionDetailData) : null}
                                                        disabled={isRecruiterIdLocked}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Select recruiter email"
                                                                variant="outlined"
                                                                size="small"
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    endAdornment: (
                                                                        <>
                                                                            {isAPiRunning.recruiterListFetching ? <CircularProgress color="inherit" size={20} /> : null}
                                                                            {params.InputProps.endAdornment}
                                                                        </>
                                                                    ),
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Tab Container */}
                                    <div className="tabContainer_bulkSubmit">
                                        <div className='tabContainerTitle_bulkSubmit'>Candidate Pool</div>
                                        <div className="tabScrollContainer_bulkSubmit">
                                            {candidateList.map((candidate, index) => {
                                                let targetData = submitDataFromModal.find((item) => item.email === candidate.emailID) || {};
                                                const isSubmittedByOther = isAPiRunning?.contentBlurred ? false : targetData?.submittedByOther || false;

                                                return (
                                                    <div
                                                        key={candidate.candidateId || candidate.id || index}
                                                        className={`candidateTab_bulkSubmit ${selectedTab === index ? 'active' : ''} ${isSubmittedByOther ? 'submittedByOther' : ''}`}
                                                        onClick={() => handleTabChange(index)}
                                                    >
                                                        <div className="tabContent_bulkSubmit">
                                                            <div className="candidateInfo_bulkSubmit">
                                                                <span className="candidateName_bulkSubmit">{candidate.name}</span>
                                                                <span className="candidateRole_bulkSubmit">{candidate.primarySkill}</span>
                                                            </div>
                                                            <div className="statusIcon_bulkSubmit">
                                                                {getCandidateStatusIcon(candidate)}
                                                            </div>
                                                            <Tooltip title="Remove candidate">
                                                                <IconButton
                                                                    size="small"
                                                                    className="removeCandidateBtn_bulkSubmit"
                                                                    onClick={e => {
                                                                        e.stopPropagation();
                                                                        removeCandidateByEmail(candidate.emailID);
                                                                    }}
                                                                    style={{ marginLeft: 8 }}
                                                                >
                                                                    <CloseIcon fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>


                                    {selectedCandidate && (
                                        <div className='candidateDetailsContainer_bulkSubmit'>

                                            <div className="candidateDetailsCard_bulkSubmit">
                                                <div className="candidateDetailsHeader_bulkSubmit">
                                                    <span className="candidateDetailsTitle_bulkSubmit">Candidate Details</span>

                                                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                                        {/* Resume Status Display */}
                                                        {hasResumeData(selectedCandidate?.candidateData?.emailID) && (
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                {getResumeIcon(selectedCandidate?.candidateData?.emailID)}
                                                                <span style={{ fontSize: '12px', color: '#666' }}>Resume Available</span>
                                                            </div>
                                                        )}

                                                        {/* Upload/Update Resume Button - Only show after candidate data is loaded */}
                                                        {!isAPiRunning.contentBlurred && (
                                                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                {/* Resume mandatory text */}
                                                                {!hasResumeData(selectedCandidate?.candidateData?.emailID) && (
                                                                    <span style={{ color: "red", fontSize: "12px" }}>
                                                                        Resume mandatory *
                                                                    </span>
                                                                )}
                                                                <Button
                                                                    className="uploadResumeButton"
                                                                    onClick={handleUploadResumeClick}
                                                                    disabled={
                                                                        isResumeUploadLoader ||
                                                                        !selectedCandidate?.candidateData?.emailID ||
                                                                        !selectedRequisitionInfo?.requisitionDetailData?.reqreferenceId
                                                                    }
                                                                    style={{
                                                                        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                                                        color: "#fff",
                                                                        padding: "6px 12px",
                                                                        fontSize: "12px",
                                                                        border: "none",
                                                                        borderRadius: "4px",
                                                                        cursor: "pointer",
                                                                        transition: "background-color 0.3s ease",
                                                                        opacity: isResumeUploadLoader ? 0.6 : 1,
                                                                    }}
                                                                >
                                                                    {isResumeUploadLoader
                                                                        ? "Uploading..."
                                                                        : hasResumeData(selectedCandidate?.candidateData?.emailID)
                                                                            ? "Update Resume"
                                                                            : "Upload Resume"}
                                                                </Button>


                                                            </div>
                                                        )}



                                                        {/* View Resume Button - Only show after candidate data is loaded */}
                                                        {!isAPiRunning.contentBlurred && hasResumeData(selectedCandidate?.candidateData?.emailID) && (
                                                            <Button
                                                                className="viewResumeButton"
                                                                onClick={handleViewResumeClick}
                                                                style={{
                                                                    backgroundColor: '#28a745',
                                                                    color: '#fff',
                                                                    padding: '6px 12px',
                                                                    fontSize: '12px',
                                                                    border: 'none',
                                                                    borderRadius: '4px',
                                                                    cursor: 'pointer',
                                                                    transition: 'background-color 0.3s ease'
                                                                }}
                                                            >
                                                                View Resume
                                                            </Button>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="candidateDetailsContent_bulkSubmit">
                                                    <div className="candidateAvatar_bulkSubmit">
                                                        {
                                                            selectedCandidate.candidateData?.name
                                                                ? selectedCandidate.candidateData?.name
                                                                    .split(' ')
                                                                    .map((n) => n[0])
                                                                    .join('')
                                                                    .toUpperCase()
                                                                : ''
                                                        }
                                                    </div>
                                                    <div className="candidateInfo_bulkSubmit">
                                                        <div className="candidateInfoRow_bulkSubmit">
                                                            <span className="candidateInfoLabel_bulkSubmit">Name:</span>
                                                            <span className="candidateInfoValue_bulkSubmit">{selectedCandidate.candidateData?.name}</span>
                                                        </div>
                                                        <div className="candidateInfoRow_bulkSubmit">
                                                            <span className="candidateInfoLabel_bulkSubmit">Email:</span>
                                                            <span className="candidateInfoValue_bulkSubmit">{selectedCandidate.candidateData?.emailID}</span>
                                                        </div>
                                                        {sourcePage === 'Activity' && !isAPiRunning.contentBlurred && (
                                                            <div className="candidateInfoRow_bulkSubmit">
                                                                <span className="candidateInfoLabel_bulkSubmit">Primary Recruiter:</span>
                                                                <span className="candidateInfoValue_bulkSubmit">{selectedCandidate.submitData?.recruiterData?.displayName}</span>
                                                            </div>
                                                        )}
                                                        {/* Add more fields as needed */}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Configurable content wrapper - content that gets blurred when recruiter not selected */}
                                            <div className={`configurableContentWrapper_bulkSubmit ${(isAPiRunning.contentBlurred || contentLoader) ? 'blurred' : ''}`}>
                                                {(isAPiRunning.contentBlurred || selectedCandidate.submittedByOther) && (
                                                    isAPiRunning.contentBlurred ?
                                                        <div className="recruiterSelectionOverlay_bulkSubmit">
                                                            <LockOutline className="lockIcon_bulkSubmit" />
                                                            <div className="overlayMessage_bulkSubmit">Please Wait . . .</div>
                                                            <div className="overlaySubMessage_bulkSubmit">Candidate information is yet to be loaded</div>
                                                        </div>
                                                        : selectedCandidate.submittedByOther ?
                                                            <div className="recruiterSelectionOverlay_bulkSubmit candidateAlreadyAdded">
                                                                <LockOutline className="lockIcon_bulkSubmit" />
                                                                <div className="overlaySubMessage_bulkSubmit">Candidate is already added to this requisition by other recruiter</div>
                                                            </div>
                                                            :
                                                            null
                                                )}

                                                <div className="configurableContent_bulkSubmit">
                                                    <div className="selectStageContainer_bulkSubmit">
                                                        <label className="selectStagLabel">Current Stage</label>
                                                        <div className="selectStageInputContainer_bulkSubmit">
                                                            <Autocomplete
                                                                className="autocomplete_selecetStage_bulkSubmit"
                                                                options={getFilteredRequisitionStatus()} // Add your role options here
                                                                getOptionLabel={(option) => option.name || ''}
                                                                value={selectedCandidate?.submitData?.status || null}
                                                                disabled={!selectedCandidate?.submitData?.candidateReqExist 
                                                                    ||selectedCandidate?.submitData?.submissionType === "Internal"}
                                                                onChange={(e, value) => updateSubmitDataState("status", value)}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        placeholder="Select stage"
                                                                        variant="outlined"
                                                                        size="small"
                                                                    />
                                                                )}
                                                            />
                                                            {selectedCandidate?.submitData?.candidateReqExist && (
                                                                <button className="editStagesButton_bulkSubmit" onClick={(e) => setEditCandidateStageToggle(true)}>
                                                                    {/* <Settings className="buttonIcon_bulkSubmit" /> */}
                                                                    <Visibility className="buttonIcon_bulkSubmit" />
                                                                    Review other stages
                                                                </button>
                                                            )}
                                                            {selectedCandidate?.submitData?.candidateRequisitionId && (
                                                                <button className="editStagesButton_bulkSubmit" onClick={goToHistory}>
                                                                    <Visibility className="buttonIcon_bulkSubmit" />
                                                                    Candidate  History
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {selectedCandidate?.submitData?.candidateRequisitionAttachments?.approvalStatus?.isRejected &&
                                                        <div className='rtrDeclinedWarning'>
                                                            <Warning className="rtrWarningIcon" />
                                                            <span>The candidate has already declined the RTR. Proceeding with the stage change will resend the RTR to the candidate.</span>
                                                        </div>
                                                    }

                                                    <div className='detailInfoContainer_bulkSubmit'>
                                                        <div
                                                            className='detailInfoContainerTitle_bulkSubmit'
                                                            onClick={() => toggleAccordion('requiredFields')}
                                                        >
                                                            <ArrowSubmit className={`arrowIcon_bulkSubmit ${expandedAccordions.requiredFields ? 'expanded' : ''}`} />
                                                            <span>Require fields for this stage</span>
                                                        </div>
                                                        {expandedAccordions.requiredFields && !isAPiRunning.contentBlurred &&
                                                            (
                                                                <div className="sectionContent_bulkSubmit">
                                                                    <div className="formContainer_bulkSubmit">
                                                                        <Grid container spacing={3}>
                                                                            {renderStageRequiredField(
                                                                                selectedCandidate.submitData,
                                                                                candidateRequisitionStatus,
                                                                                selectedRequisitionInfo.requisitionDetailData,
                                                                                updateSubmitDataState,
                                                                                null,
                                                                                handleMandatoryFieldsValidation
                                                                            )
                                                                            }
                                                                        </Grid>
                                                                    </div>
                                                                </div>

                                                            )
                                                        }
                                                    </div>
                                                    {(selectedCandidate?.submitData?.candidateRequisitionAttachments &&
                                                        selectedCandidate?.submitData?.submissionType !== "Internal") && (
                                                            <div className='detailInfoContainer_bulkSubmit'>
                                                                <div
                                                                    className='detailInfoContainerTitle_bulkSubmit'
                                                                    onClick={() => toggleAccordion('rightToRepresent')}
                                                                >
                                                                    <ArrowSubmit className={`arrowIcon_bulkSubmit ${expandedAccordions.rightToRepresent ? 'expanded' : ''}`} />
                                                                    <span>Right to Represent</span>
                                                                </div>
                                                                {expandedAccordions.rightToRepresent && (
                                                                    <div className="sectionContent_bulkSubmit">
                                                                        <div className="rtrContainer_bulkSubmit">
                                                                            <div className='rtrMainContainer' style={{ marginTop: '10px' }}>
                                                                                <div className='rtrContainerStyled'>
                                                                                    <div className='rtrStatusSection'>
                                                                                        <span className='rtrStatusLabel'>Status:</span>
                                                                                        {selectedCandidate?.submitData?.candidateRequisitionAttachments?.approvalStatus?.isPending === true &&
                                                                                            <div className='rtr_content rtr_pending'>
                                                                                                <Pending />
                                                                                                <span className='rtr_status_text'>Awaiting Approval</span>
                                                                                            </div>
                                                                                        }
                                                                                        {selectedCandidate?.submitData?.candidateRequisitionAttachments?.approvalStatus?.isRejected === true &&
                                                                                            <div className='rtr_content rtr_rejected'>
                                                                                                <Rejected />
                                                                                                <span className='rtr_status_text'>Candidate Declined</span>
                                                                                            </div>
                                                                                        }
                                                                                        {selectedCandidate?.submitData?.candidateRequisitionAttachments?.approvalStatus?.isApproved === true &&
                                                                                            <div className='rtr_content rtr_approved'>
                                                                                                <Approved />
                                                                                                <span className='rtr_status_text'>RTR Approved</span>
                                                                                            </div>
                                                                                        }
                                                                                    </div>
                                                                                    {selectedCandidate?.submitData?.candidateRequisitionAttachments?.approvalStatus?.isApproved === true &&
                                                                                        <button
                                                                                            className='viewRtrButton'
                                                                                            onClick={() => handleFetchRtr()}
                                                                                        >
                                                                                            <span>View RTR</span>
                                                                                        </button>
                                                                                    }
                                                                                    {selectedCandidate?.submitData?.candidateRequisitionAttachments?.approvalStatus?.isRejected === true &&
                                                                                        <button
                                                                                            className='viewRtrButton'
                                                                                            onClick={() => resendRTREmail()}
                                                                                            disabled={isAPiRunning.rtrResending}
                                                                                        >
                                                                                            {isAPiRunning.rtrResending ? (
                                                                                                <>
                                                                                                    <CircularProgress size={16} style={{ marginRight: '8px', color: 'white' }} />
                                                                                                    <span>Resending...</span>
                                                                                                </>
                                                                                            ) : (
                                                                                                <span>Resend RTR</span>
                                                                                            )}
                                                                                        </button>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    {(
                                                        !(
                                                            selectedCandidate?.submitData?.candidateReqExist &&
                                                            selectedCandidate?.submitData?.candidateSubmissionData?.details?.length === 0
                                                        ) && (
                                                            (
                                                                (selectedRequisitionInfo?.requisitionDetailData.spocData?.isActive &&
                                                                    selectedRequisitionInfo?.requisitionDetailData.spocData?.isEmailRequired) ||
                                                                (!selectedCandidate?.submitData?.candidateReqExist &&
                                                                    selectedCandidate?.submitData?.candidateSubmissionData?.details?.length > 0) ||
                                                                (selectedRequisitionInfo?.requisitionDetailData?.clientData?.isEmailRequired &&
                                                                    selectedRequisitionInfo?.requisitionDetailData?.clientData?.isActive)
                                                            ) && (
                                                                <div className="detailInfoContainer_bulkSubmit">
                                                                    <div
                                                                        className="detailInfoContainerTitle_bulkSubmit"
                                                                        onClick={() => toggleAccordion('candidateSubmission')}
                                                                    >
                                                                        <ArrowSubmit
                                                                            className={`arrowIcon_bulkSubmit ${expandedAccordions.candidateSubmission ? 'expanded' : ''}`}
                                                                        />
                                                                        <span>Candidate Submission fields</span>
                                                                    </div>
                                                                    {expandedAccordions.candidateSubmission && (
                                                                        <SubmissionComp
                                                                            submitDataFromModal={submitDataFromModal}
                                                                            setSubmitDataFromModal={setSubmitDataFromModal}
                                                                            selectedCandidate={selectedCandidate}
                                                                            setSelectedCandidate={setSelectedCandidate}
                                                                            reqDetailData={selectedRequisitionInfo?.requisitionDetailData}
                                                                            candidateSubmissionField={candidateSubmissionField}
                                                                            sharedAdditionalSpoc={sharedAdditionalSpoc}
                                                                            setSharedAdditionalSpoc={setSharedAdditionalSpoc}
                                                                            onAdditionalSpocRequirementChange={setIsAdditionalSpocRequiredGlobal}
                                                                            onSubmissionConfigStatusChange={setHasActiveSubmissionConfig}
                                                                            onFormatSubmissionData={handleFormattedSubmissionData}
                                                                            currencyOptions={currencyOptions}
                                                                            setCurrencyOptions={setCurrencyOptions}
                                                                        />
                                                                    )}
                                                                </div>
                                                            )
                                                        )
                                                    )}


                                                    <div className='detailInfoContainer_bulkSubmit'>
                                                        <div
                                                            className='detailInfoContainerTitle_bulkSubmit'
                                                            onClick={() => toggleAccordion('formData')}
                                                        >
                                                            <ArrowSubmit className={`arrowIcon_bulkSubmit ${expandedAccordions.formData ? 'expanded' : ''}`} />
                                                            <span>Form data</span>
                                                        </div>
                                                        {expandedAccordions.formData && (
                                                            <div className="sectionContent_bulkSubmit">
                                                                <div className="formContainer_bulkSubmit">
                                                                    <Grid container spacing={3}>
                                                                        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                                                                            <div className="fieldContainer_bulkSubmit">
                                                                                <label className="fieldLabel_requiredFields">Current Status*</label>
                                                                                <Autocomplete
                                                                                    className="autocomplete_bulkSubmit"
                                                                                    options={candidateFields.currentStatus || []}
                                                                                    getOptionLabel={(option) => option.name || ""}
                                                                                    value={candidateFields.currentStatus?.find(option => option.name === selectedCandidate?.submitData?.candidateRequisitionInfoFields?.currentStatus) || null}
                                                                                    isOptionEqualToValue={(option, value) => option.name === value?.name}
                                                                                    onChange={(e, newValue) => { updateFormValue('currentStatus', newValue?.name || '') }}
                                                                                    renderInput={(params) => (
                                                                                        <TextField
                                                                                            {...params}
                                                                                            placeholder="Select current status"
                                                                                            variant="outlined"
                                                                                            size="small"
                                                                                        />
                                                                                    )}
                                                                                />
                                                                            </div>
                                                                        </Grid>

                                                                        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                                                                            <div className="fieldContainer_bulkSubmit">
                                                                                <label className="fieldLabel_requiredFields">Recruitment leader email*</label>
                                                                                <Autocomplete
                                                                                    className="autocomplete_bulkSubmit"
                                                                                    options={[]}
                                                                                    getOptionLabel={(option) => option.email || ""}
                                                                                    value={selectedCandidate?.submitData?.candidateRequisitionInfoFields?.recruitmentLeaderInfo}
                                                                                    disabled
                                                                                    renderInput={(params) => (
                                                                                        <TextField
                                                                                            {...params}
                                                                                            placeholder="Select recruitment leader"
                                                                                            variant="outlined"
                                                                                            size="small"
                                                                                        />
                                                                                    )}
                                                                                />
                                                                            </div>
                                                                        </Grid>
                                                                        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                                                                            <div className="fieldContainer_bulkSubmit">
                                                                                <label className="fieldLabel_requiredFields">Team leader email*</label>
                                                                                <Autocomplete
                                                                                    className="autocomplete_bulkSubmit"
                                                                                    options={[]} // Add your submission type options here
                                                                                    getOptionLabel={(option) => option.email || ""}
                                                                                    value={selectedCandidate?.submitData?.candidateRequisitionInfoFields?.teamLeaderInfo}
                                                                                    disabled
                                                                                    renderInput={(params) => (
                                                                                        <TextField
                                                                                            {...params}
                                                                                            placeholder="N/A"
                                                                                            variant="outlined"
                                                                                            size="small"
                                                                                        />
                                                                                    )}
                                                                                />
                                                                            </div>
                                                                        </Grid>

                                                                        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                                                                            <div className="fieldContainer_bulkSubmit">
                                                                                <label className="fieldLabel_requiredFields">Gender*</label>
                                                                                <Autocomplete
                                                                                    className="autocomplete_bulkSubmit"
                                                                                    options={candidateFields.gender || []}
                                                                                    getOptionLabel={(option) => option.name || ""}
                                                                                    value={candidateFields.gender?.find(option => option.name === selectedCandidate?.submitData?.candidateRequisitionInfoFields?.gender) || null}
                                                                                    isOptionEqualToValue={(option, value) => option.name === value?.name}
                                                                                    onChange={(e, newValue) => { updateFormValue('gender', newValue?.name || '') }}
                                                                                    renderInput={(params) => (
                                                                                        <TextField
                                                                                            {...params}
                                                                                            placeholder="Select gender"
                                                                                            variant="outlined"
                                                                                            size="small"
                                                                                        />
                                                                                    )}
                                                                                />
                                                                            </div>
                                                                        </Grid>

                                                                    </Grid>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    )}
                                </>
                            }
                        </>}
                </DialogContent>
                <DialogActions className="dialogActions_bulkSubmit">
                    {!editCandidateStageToggle && (
                        <div className="leftActionSection_bulkSubmit">
                        </div>
                    )}
                    {editCandidateStageToggle && (
                        <div className="leftActionSection_bulkSubmit">
                        </div>
                    )}
                    <div className="rightActionSection_bulkSubmit">
                        {editCandidateStageToggle ? (
                            <>
                                <button
                                    variant="outlined"
                                    className="cancelButton_bulkSubmit"
                                    onClick={() => setEditCandidateStageToggle(false)}
                                >
                                    <ArrowBack className="buttonIcon_bulkSubmit" />
                                    <span>Go back</span>
                                </button>
                                {/* Save button removed as requested */}
                            </>
                        ) : (
                            <>
                                <button
                                    variant="outlined"
                                    className="cancelButton_bulkSubmit"
                                    onClick={() => handleCloseModal()}
                                >
                                    Cancel
                                </button>
                                <button
                                    variant="contained"
                                    className="completeFormsButton_bulkSubmit"
                                    onClick={handleBulkSubmit}
                                    disabled={isSubmitting || isSubmitDisabled}
                                >
                                    {isSubmitting ? (
                                        <span className="loadingWrapper_bulkSubmit">
                                            <CircularProgress size={16} thickness={4} color="inherit" />
                                            <span>Submitting...</span>
                                        </span>
                                    ) : (
                                        "Submit"
                                    )}
                                </button>
                            </>
                        )}
                    </div>
                </DialogActions>
            </Dialog>
            <Dialog
                open={rtrDialogOpen}
                aria-labelledby="dialog-title"
                className="rtr_dialog"
                maxWidth="xl"
                fullWidth
                fullScreen
                onClose={() => handleRTRModalClose()}>
                <DialogTitle className="rtr_dialog_title">
                    <span className="rtrTitle">Right To Represent</span>
                </DialogTitle>
                <DialogContent>
                    {isAPiRunning.rtrFetching ?
                        <div className="rtr_dialog_loading">
                            <CircularProgress />
                            <span>Loading...</span>
                        </div>
                        :
                        <Grid container className="rtr_dialog_content">
                            <Grid size={{ xs: 12 }} className="rtr_dialog_content_text">
                                <div
                                    className='docx-content'
                                    dangerouslySetInnerHTML={{ __html: selectedCandidate?.submitData?.rtrText || '' }}
                                />
                            </Grid>
                        </Grid>
                    }
                </DialogContent>

                <DialogActions className='dialog-actions-viewrtr'>
                    <button className='cancel-button' onClick={() => handleRTRModalClose()}>
                        <span>Cancel</span>
                    </button>
                    <button className='download-rtr-button' onClick={() => downloadRTRDocx(rtrData.rtrLinkdownload)} disabled={isAPiRunning.rtrFetching}>
                        <Download />
                        <span>Download</span>
                    </button>
                </DialogActions>
            </Dialog>
            {historyModal &&
                <RecruiterCandidateHistory
                    open={historyModal}
                    onClose={() => setHistoryModal(false)}
                    recruitmentpartnerId={recruitmentpartnerId}
                    canReqId={selectedCandidate?.submitData?.candidateRequisitionId}
                />
            }
            {showResumeModal && <UploadResumeModal
                showResumeModal={showResumeModal}
                setShowResumeModal={setShowResumeModal}
                id={userId}
                sendDataToActivityModal={(data) => handleDataFromModal(data, selectedCandidate?.candidateData?.emailID)}
                handleResumeLoader={(loader) => handleResumeLoader(loader, selectedCandidate?.candidateData?.emailID)}
                activityModalUsed={true}
                isSaveModel={true}
                setisActivity={() => { }} // Not needed in bulk submit context
                userRecruitmentpartnerId={recruitmentpartnerId}
                singleFileSelect={true}
            />}
        </>
    )
}

export default BulkSubmitModal

